import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { trackFormSubmission, trackSignUp } from '../utils/analytics';
import './InsightsHub.css';
import Turnstile from './Turnstile';

const InsightsHub = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState('');
  const [verificationReset, setVerificationReset] = useState(0);

  const articles = [
    {
      title: 'Why busy salons still feel broke',
      slug: 'why-busy-salons-still-feel-broke'
    },
    {
      title: 'The metric owners ignore until it\'s too late',
      slug: 'the-metric-owners-ignore'
    },
    {
      title: 'Why AI alone doesn\'t fix front desk burnout',
      slug: 'why-ai-doesnt-fix-front-desk-burnout'
    }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token || isSubmitting) return;
    setIsSubmitting(true);
    setError(null);

    try {
      await axios.post(
        'https://thx8odn37g.execute-api.us-west-2.amazonaws.com/prod/subscribe',
        { email, 'cf-turnstile-response': token }
      );

      // Track successful subscription
      trackFormSubmission('newsletter_signup');
      trackSignUp('newsletter');

      setSubscribed(true);
      setEmail('');
    } catch (err) {
      console.error('Subscription error:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setToken('');
      setVerificationReset(value => value + 1);
    }

    setIsSubmitting(false);
  };

  return (
    <section id="insights-hub" className="insights-hub-section">
      <div className="container">
        <h2 className="section-title">What we're seeing across modern salons</h2>

        <div className="articles-list">
          {articles.map((article, index) => (
            <Link key={index} to={`/blog/${article.slug}`} className="article-item">
              <span className="article-icon">→</span>
              <span className="article-title">{article.title}</span>
            </Link>
          ))}
        </div>

        <div className="newsletter-signup">
          <h3 className="signup-title">Join other salon owners getting weekly insights</h3>
          {!subscribed ? (
            <form onSubmit={handleSubmit} className="signup-form">
              <label htmlFor="newsletter-email" className="visually-hidden">Email address</label>
              <input
                id="newsletter-email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isSubmitting}
                className="email-input"
                aria-label="Email address"
              />
              <Turnstile action="newsletter" onToken={setToken} resetKey={verificationReset} />
              <button type="submit" className="btn btn-submit" disabled={isSubmitting || !token}>
                {isSubmitting ? 'Subscribing...' : 'Get Insights'}
              </button>
              {error && <p className="error-message">{error}</p>}
            </form>
          ) : (
            <p className="success-message">✓ Almost done! Check your inbox and click the link to confirm your subscription.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default InsightsHub;
